import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { MAT_DIALOG_DATA } from '@angular/material';

@Component({
  selector: 'app-ranking-overwrite',
  templateUrl: './ranking-overwrite.component.html',
  styleUrls: ['./ranking-overwrite.component.scss']
})
export class RankingOverwriteComponent implements OnInit {

  constructor(
    @Inject(MAT_DIALOG_DATA) public data,
    public dialogRef: MatDialogRef<RankingOverwriteComponent>) { }

  ngOnInit() {
  }

  confirm(){
    if (this.data.type == 'overwrite'){
      this.dialogRef.close({
        overwrite: true,
        exist_id: this.data.exist_id
      });
    } else if (this.data.type == 'default'){
      this.dialogRef.close({
        default: true,
        rank_id: this.data.rank_id
      });
    }
  }

  deny(){
    if (this.data.type == 'overwrite'){
      this.dialogRef.close({
        overwrite: false,
        exist_id: this.data.exist_id
      });
    } else if (this.data.type == 'default'){
      this.dialogRef.close({
        default: false,
        rank_id: this.data.rank_id
      });
    }
  }

}
